export const playMode = {
  sequence: 0,
  loop: 1,
  random: 2
}



// WEBPACK FOOTER //
// ./src/common/js/config.js